import { use, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  ContractDetailModel,
  EnvelopeSubmissionStatus,
  EnvelopeSubmissionType,
} from '@urbanx/agx-ui-components';
import {
  useInvalidateUseStaffGetContract,
  useStaffGetContract,
} from '@urbanx/agx.campaigns.client';
import { NotificationContext } from 'contexts';
import { CampaignUpdatedEvent, NotificationType } from 'types/pushNotifications';

const useSelectedContract = (): {
  contract?: ContractDetailModel;
  isDocuSigned: boolean;
  isLoading: boolean;
  isFetched: boolean;
  campaignId?: string;
} => {
  const { campaignId, contractId } = useParams();
  const notifications = use(NotificationContext);
  const invalidateUseStaffGetContract = useInvalidateUseStaffGetContract();

  useEffect(() => {
    if (!contractId) return;

    const campaignUpdated = async (event: CampaignUpdatedEvent) => {
      if (event.campaignId === campaignId) {
        await invalidateUseStaffGetContract(contractId);
      }
    };

    notifications?.registerEvent(NotificationType.CampaignUpdatedEvent, campaignUpdated, [
      contractId,
    ]);
  }, [campaignId, contractId, notifications]);

  const { data: staffContract, isPending } = useStaffGetContract(contractId || '', !!contractId);
  const contract = staffContract as ContractDetailModel | undefined;

  const isDocuSigned =
    contract?.envelopeSubmission?.type === EnvelopeSubmissionType.DocuSign &&
    (contract?.envelopeSubmission?.status === EnvelopeSubmissionStatus.Signed ||
      contract?.envelopeSubmission?.status === EnvelopeSubmissionStatus.Complete);

  return {
    contract,
    isDocuSigned,
    isLoading: !!contractId && isPending,
    isFetched: !!contractId && !isPending,
    campaignId,
  };
};

export default useSelectedContract;
